import {
  APPLICANTDOCUMENT_LOADING,
  GET_APPLICANTDOCUMENT,
  GET_APPLICANTDOCUMENT_SUCCESS,
  GET_APPLICANTDOCUMENT_FAIL,
  ADD_APPLICANTDOCUMENT_SUCCESS,
  ADD_APPLICANTDOCUMENT_FAIL,
  DELETE_APPLICANTDOCUMENT_SUCCESS,
  DELETE_APPLICANTDOCUMENT_FAIL,
  UPDATE_APPLICANTDOCUMENT_SUCCESS,
  UPDATE_APPLICANTDOCUMENT_FAIL,
  APPLICANTDOCUMENT_RESET
} from "./actionType";

const INIT_STATE = {
  applicantDocuments: [],
  error: {},
};

const ApplicantDocument = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_APPLICANTDOCUMENT_SUCCESS:
      switch (action.payload.actionType) {
        case GET_APPLICANTDOCUMENT:
          return {
            ...state,
            applicantDocuments: action.payload.data,
            isApplicantDocumentCreated: false,
            isApplicantDocumentSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_APPLICANTDOCUMENT_FAIL:
      switch (action.payload.actionType) {
        case GET_APPLICANTDOCUMENT_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isApplicantDocumentCreated: false,
            isApplicantDocumentSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_APPLICANTDOCUMENT: {
      return {
        ...state,
        isApplicantDocumentCreated: false,
        loading: true,
      };
    }

    case APPLICANTDOCUMENT_LOADING: {
      return {
        ...state,
        isApplicantDocumentCreated: false,
        loading: true,
      };
    }

    case ADD_APPLICANTDOCUMENT_SUCCESS:
      return {
        ...state,
        isApplicantDocumentCreated: true,
        loading: false,
        applicantDocuments: [action.payload.data, ...state.applicantDocuments],
      };

    case ADD_APPLICANTDOCUMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_APPLICANTDOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        applicantDocuments: state.applicantDocuments.filter(
          civilApplicantDocument => civilApplicantDocument.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_APPLICANTDOCUMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_APPLICANTDOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        applicantDocuments: state.applicantDocuments.map(civilApplicantDocument =>
          civilApplicantDocument.id.toString() === action.payload.data.id.toString() ? { ...civilApplicantDocument, ...action.payload.data } : civilApplicantDocument
        ),
      };

    case UPDATE_APPLICANTDOCUMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case APPLICANTDOCUMENT_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default ApplicantDocument;